// src/lib/constants.js
// src/lib/constants.js

import logo from "../assets/logo.png";

export const LOGO_URL = logo;

export const BRAND = {
  name: "JustZeta",
  website: "https://justzeta.com",
  email: "contact@justzeta.com",
  tagline: "Modern Digital Document Management Platform",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Pricing", to: "/pricing" },
  { label: "Contact", to: "/contact" },
];

export const SOCIALS = [
  { name: "LinkedIn", href: "https://linkedin.com", icon: "Linkedin" },
  { name: "X", href: "https://x.com", icon: "Twitter" },
  { name: "Facebook", href: "https://facebook.com", icon: "Facebook" },
  { name: "Instagram", href: "https://instagram.com", icon: "Instagram" },
  { name: "GitHub", href: "https://github.com", icon: "Github" },
];
